export default __webpack_public_path__ + "static/media/SubWebVideo.4e1405a9.png";